import { Icon, Props } from "./CheckIcon.Parts";

export const CheckIcon = ({ small, ...props }: Props) => (
  <Icon
    $small={small}
    viewBox="0 0 12 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.75347 9.84925L0.110513 6.20629C-0.0368376 6.05894 -0.0368376 5.8194 0.110513 5.67205L1.71323 4.06933C1.86058 3.92198 2.10012 3.92198 2.24747 4.06933L3.75347 5.57533C3.90082 5.72268 4.14036 5.72268 4.28771 5.57533L9.75253 0.110512C9.89988 -0.0368381 10.1394 -0.0368381 10.2868 0.110512L11.8895 1.71323C12.0368 1.86058 12.0368 2.10012 11.8895 2.24747L4.28771 9.84925C4.14036 9.9966 3.90082 9.9966 3.75347 9.84925Z"
      fill="currentColor"
    />
  </Icon>
);
